module.exports = __webpack_public_path__ + "static/media/credentials.3a368be9.svg";